import { Component, Input, OnInit } from '@angular/core';
import FinSupplierCardDTO from 'src/app/invopay/interfaces/fin-supplier-card-dto';
import IpErrorResponse from 'src/app/invopay/interfaces/ip-error-response';
import { FnAccountFinanceService } from 'src/app/invopay/services/fn-account-finance.service';
import { IpSnackbarService } from 'src/app/invopay/services/ip-snackbar.service';

@Component({
  selector: 'app-fn-card-info',
  templateUrl: './fn-card-info.component.html',
  styleUrls: ['./fn-card-info.component.scss']
})
export class FnCardInfoComponent implements OnInit {
  @Input() selectedSupplierId?: number;
  cardInfo?: FinSupplierCardDTO;
  isMenuOpen: boolean = false;

  constructor(
    private fnAccountFinanceService: FnAccountFinanceService,
    private ipSnackbarService: IpSnackbarService,
  ) { }

  ngOnInit() {
    this.fnAccountFinanceService.getCardInfo(this.selectedSupplierId).subscribe({
      next: (data: FinSupplierCardDTO) => {
        if (data) {
          this.cardInfo = data;
        }
      },
      error: (e: IpErrorResponse) => {
        this.ipSnackbarService.showErrorMessage(e);
      },
    })
  }

  cardBlockListener() {
    this.ipSnackbarService.showSuccessMessage(
      'La tarjeta ha sido bloqueada.'
    );
    if (this.cardInfo) {
      this.cardInfo.cardStatus = 'BLOCKED';
    }
  }
}
